exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-blockquote {\n  border-left: 0.4em solid #8c8c8c;\n}\n.uu5-bricks-blockquote.blockquote-reverse,\n.uu5-bricks-blockquote.blockquote.pull-right {\n  border-right: 0;\n  padding: 10px 20px;\n}\n.uu5-bricks-blockquote.uu5-bricks-blockquote-bg {\n  background-color: #f5f5f5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/blockquote.less
// module id = 188
// module chunks = 0